import merge from 'lodash/merge'


const physicsSettingsSmall = {
  springLength: 15,
  repulsion: 70,
  convergeSpeed: 12,
  stiffness: 400
}

const physicsSettingsLarge = {
  springLength: 20,
  repulsion: 100,
  convergeSpeed: 12,
  stiffness: 600
}

export const physicsSettings = {
  stiffness: 500, //200
  springLength: 20,
  repulsion: 75, // 75
  damping: 0.5, // .9
  convergeSpeed: 12, // 50
  wallForce: 1000,
  centerAttraction: 1.25,
  focusModifier: 0,// 0.005,
  speedLimit: 800, // 200
  scaler: 0.02, // .05
  stepsPerFrame: 5,
  // Torque scales with sin(angle error), which is tiny once nearly aligned, so it
  // needs to be much larger than the other force constants to actually win out
  // against hookesLaw/repulsion at small residual angles.
  angularStiffness: 100000,
}

const layoutSettingsSmall = {
  arrowHeadSize: 4,
  nodeSizeMultiplier: 2,
  edgeSizeMultiplier: 3
}

const layoutSettingsLarge = {
  arrowHeadSize: 7,
  nodeSizeMultiplier: 2,
  edgeSizeMultiplier: 3
}

export const layoutSettings = {
  arrowHeadSize: 7,
  nodeSizeMultiplier: 2,
  edgeSizeMultiplier: 4
}

const screenSmMax = 768

export const updateSpringLength = (screenWidth: number) => {
  if (screenWidth < screenSmMax) {
    merge(physicsSettings, physicsSettingsSmall)
    merge(layoutSettings, layoutSettingsSmall)
  } else {
    merge(physicsSettings, physicsSettingsLarge)
    merge(layoutSettings, layoutSettingsLarge)
  }
}
